import React from "react";
import { Flex, Box, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

export default function Services() {
  return (
    <Stack alignItems="center" py={10}>
      <Heading
        fontWeight={"semibold"}
        fontSize={{ base: "27px", md: "40px" }}
        textAlign={{ base: "center", md: "none" }}
      >
        Popular professional services
      </Heading>
      <Flex width="100%" py={10} justifyContent="center">
        <Swiper
          slidesPerView={"5"}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            "@0.00": {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            "480": {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            "770": {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            900: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1100: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
          }}
          loop={true}
          className="mySwiper homeServicesSlider"
          modules={[Navigation]}
          navigation={true}
        >
          {servicesData.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <Link to={`/marketplace/logo-design`}>
                  <Box
                    key={item.imageUrl}
                    px={{ base: 2, md: 0 }}
                    pos="relative"
                  >
                    <Image src={item.imageUrl} w="full" />
                    <Box
                      pos="absolute"
                      top={8}
                      left={{ base: 4, "2xl": 6 }}
                      color="white"
                    >
                      <Text
                        fontSize={{ base: "10px", "2xl": "15px" }}
                        fontWeight="semibold"
                      >
                        {item.text}
                      </Text>
                      <Text
                        fontSize={{
                          base: "16px",
                          md: "17px",
                          lg: "14px",
                          "2xl": "24px",
                        }}
                        fontWeight="bold"
                      >
                        {item.heading}
                      </Text>
                    </Box>
                  </Box>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Flex>
    </Stack>
  );
}

const servicesData = [
  {
    imageUrl: "/images/home/services/logo-design.png",
    heading: "Logo Design",
    text: "Build your brand",
  },
  {
    imageUrl: "/images/home/services/wordpress.png",
    heading: "Wordpress",
    text: "Customize your site",
  },
  {
    imageUrl: "/images/home/services/voice-over.png",
    heading: "Voice Over",
    text: "Share your message",
  },
  {
    imageUrl: "/images/home/services/video-editing.png",
    heading: "Video Editing",
    text: "Engage with people",
  },
  {
    imageUrl: "/images/home/services/social-media.png",
    heading: "Social Media",
    text: "Reach more customers",
  },
  {
    imageUrl: "/images/home/services/logo-design.png",
    heading: "Logo Design",
    text: "Build your brand",
  },
  {
    imageUrl: "/images/home/services/wordpress.png",
    heading: "Wordpress",
    text: "Customize your site",
  },
  {
    imageUrl: "/images/home/services/voice-over.png",
    heading: "Voice Over",
    text: "Share your message",
  },
  {
    imageUrl: "/images/home/services/video-editing.png",
    heading: "Video Editing",
    text: "Engage with people",
  },
  {
    imageUrl: "/images/home/services/social-media.png",
    heading: "Social Media",
    text: "Reach more customers",
  },
];
